import { resolveWsUrl } from '../core/path';
import type { WsEvent, WsKind } from '../domains/iot/iot.types';
import { useLiveSocket, type UseLiveSocketResult } from './useLiveSocket';

interface UseLiveRoomOptions {
  /** Called for every incoming WsEvent */
  onEvent: (event: WsEvent) => void;
  enabled?: boolean;
}

/** Subscribe to a location's live stream (`/ws/{kind}/{code}`): actuator state + sensor
 *  signals for the room and (for grow rooms) its racks. */
export function useLiveRoom(
  kind: WsKind,
  code: string,
  { onEvent, enabled = true }: UseLiveRoomOptions,
): UseLiveSocketResult {
  return useLiveSocket<WsEvent>({
    resolveUrl: () => resolveWsUrl(kind, code),
    onEvent,
    enabled: enabled && !!code,
    deps: [kind, code],
  });
}
